import request from "@/utils/request";

export default {
    getData: () => {
        return request.get(`/app/setting/currentTime`)
    },
}

